import React, { useEffect, useRef, useState } from 'react';
import axios from "axios";
import { useParams } from "react-router-dom";
import "./ApplyModal.css";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

function ApplyModal({ isOpen, onClose }) {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSchool, setSelectedSchool] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const { school_slug } = useParams();
  const [alertState, setAlertState] = useState({
    show: false,
    title: "",
    message: "",
    type: "success"
  });

  useEffect(() => {
    const loadSchools = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${baseAPIUrl}admin/general_settings/get_schools/`,
          { withCredentials: true }
        );

        if (res.data.status === 1 && res.data.data) {
          const schoolList = res.data.data;
          setSchools(schoolList);

          // 🔥 If URL contains school_slug
          if (school_slug) {
            const matchedSchool = schoolList.find(
              (school) =>
                school.school_slug.toLowerCase() === school_slug.toLowerCase()
            );

            if (matchedSchool) {
              setSelectedSchool(matchedSchool.id);

              setFormData(prev => ({
                ...prev,
                school: matchedSchool.id
              }));

              fetchClasses(matchedSchool.id);
            }
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadSchools();
  }, [school_slug]);

  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");

  const fetchClasses = async (schoolId) => {
    if (!schoolId) {
      setClasses([]);
      return;
    }

    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/general_settings/get_classes/${schoolId}`,
        { withCredentials: true }
      );

      if (res.data.status === 1) {
        setClasses(res.data.data || []);
      } else {
        setClasses([]);
      }

    } catch (error) {
      console.error(error);
      setClasses([]);
    }
  };

  const statesOfIndia = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry"
  ];

  const [formData, setFormData] = useState({
    parentName: "",
    studentName: "",
    email: "",
    mobile: "",
    school: "",
    className: "",
    state: "",
    cityName: "",
  });

  const [errors, setErrors] = useState({
    parentName: "",
    studentName: "",
    email: "",
    mobile: "",
    school: "",
    className: "",
    state: "",
    cityName: "",
  });

  const validateName = (name) => {
    const regex = /^[A-Za-z ]*$/;
    return regex.test(name);
  };

  const handleNameChange = (field, value) => {

    if (!validateName(value)) {
      return; // block invalid characters
    }

    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    // remove error if valid
    setErrors(prev => ({
      ...prev,
      [field]: ""
    }));
  };

  const [formValid, setFormValid] = useState(false);

  // Indian mobile validation
  const validateMobile = (number) => {
    const regex = /^[6-9]\d{9}$/;
    return regex.test(number);
  };

  // Email validation
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };


  useEffect(() => {
    const isValid =
      formData.parentName.trim() !== "" &&
      formData.studentName.trim() !== "" &&
      validateEmail(formData.email) &&
      validateMobile(formData.mobile) &&
      formData.school !== "" &&
      formData.className !== "" &&
      formData.state !== "" &&
      formData.cityName !== "";
    setFormValid(isValid);
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formValid) return;

    try {
      const res = await axios.post(
        `${baseAPIUrl}admin/general_settings/save_admission_enquiry`,
        {
          ...formData,
        }
      );

      // ✅ Check API status
      if (res.data.status === 1) {
        setAlertState({
          show: true,
          title: "Thank You!",
          message: res.data.success_message,
          type: "success"
        });

        // Reset form
        setFormData({
          parentName: "",
          studentName: "",
          email: "",
          mobile: "",
          school: "",
          className: "",
          state: "",
          cityName: "",
        });

        setSelectedSchool("");
        setSelectedClass("");
        setSelectedState("");
        setClasses([]);

      } else {
        setAlertState({
          show: true,
          title: "Submission Error",
          message: res.data.success_message || "Something went wrong",
          type: "error"
        });
      }

    } catch (error) {
      console.error(error);
      setAlertState({
        show: true,
        title: "Submission Failed",
        message: "Unable to submit your enquiry at this moment. Please check your connection and try again.",
        type: "error"
      });
    }
  };



  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Admission Enquiry</h3>
              <button className="close-btn" onClick={onClose}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Enter Parent name *"
                  value={formData.parentName}
                  onChange={(e) => handleNameChange("parentName", e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: errors.parentName
                      ? '1px solid red'
                      : '1px solid rgb(100, 19, 32)',
                    borderRadius: '5px',
                    fontSize: '0.9rem',
                    fontFamily: 'Lora',
                    color: 'rgb(100, 19, 32)'
                  }}
                />
                {errors.parentName && (
                  <small style={{ color: 'red' }}>{errors.parentName}</small>
                )}
              </div>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Enter Student Name *"
                  value={formData.studentName}
                  onChange={(e) => handleNameChange("studentName", e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: errors.studentName
                      ? '1px solid red'
                      : '1px solid rgb(100, 19, 32)',
                    borderRadius: '5px',
                    fontSize: '0.9rem',
                    fontFamily: 'Lora',
                    color: 'rgb(100, 19, 32)'
                  }}
                />
                {errors.studentName && (
                  <small style={{ color: 'red' }}>{errors.studentName}</small>
                )}
              </div>
              <div className="form-group">
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  placeholder="Enter Email *"
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: errors.email
                      ? '1px solid red'
                      : '1px solid rgb(100, 19, 32)',
                    borderRadius: '5px',
                    fontSize: '0.9rem',
                    fontFamily: 'Lora'
                  }}
                />

                {formData.email && !validateEmail(formData.email) && (
                  <small style={{ color: 'red' }}>
                    Enter valid email address
                  </small>
                )}
              </div>
              <div className="form-group">
                <div style={{ display: 'flex' }}>
                  <span style={{
                    padding: '10px',
                    border: '1px solid rgb(100, 19, 32)',
                    borderRight: 'none',
                    borderRadius: '5px 0 0 5px',
                    background: '#eee',
                    fontFamily: 'Lora',
                    fontSize: '0.9rem'
                  }}>
                    +91
                  </span>

                  <input
                    type="tel"
                    maxLength="10"
                    value={formData.mobile}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '');
                      setFormData({ ...formData, mobile: value });
                    }}
                    placeholder="Enter 10 digit Mobile *"
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: errors.mobile
                        ? '1px solid red'
                        : '1px solid rgb(100, 19, 32)',
                      borderRadius: '0 5px 5px 0',
                      fontSize: '0.9rem',
                      fontFamily: 'Lora'
                    }}
                  />
                </div>

                {formData.mobile && !validateMobile(formData.mobile) && (
                  <small style={{ color: 'red' }}>
                    Enter valid Indian mobile (Starts with 6-9 & 10 digits)
                  </small>
                )}
              </div>
              <div className="form-group">
                <select
                  value={selectedSchool}
                  onChange={(e) => {
                    const schoolId = e.target.value;
                    setSelectedSchool(schoolId);
                    setSelectedClass("");      // reset class
                    fetchClasses(schoolId);    // fetch classes

                    setFormData(prev => ({
                      ...prev,
                      school: schoolId,
                      className: ""
                    }));
                  }}
                  required
                  disabled={!!school_slug}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: errors.school
                      ? '1px solid red'
                      : '1px solid rgb(100, 19, 32)',
                    borderRadius: '5px',
                    fontSize: '0.9rem',
                    fontFamily: 'Lora',
                    color: 'rgb(100, 19, 32)',
                    backgroundColor: school_slug ? '#f5f5f5' : 'white',
                    cursor: school_slug ? 'not-allowed' : 'pointer'
                  }}
                >
                  <option value="">Select School *</option>

                  {schools.map((school) => (
                    <option key={school.id} value={school.id}>
                      {school.school_name}
                    </option>
                  ))}

                </select>
              </div>
              <div className="form-group">
                <select
                  value={selectedClass}
                  onChange={(e) => {
                    const classValue = e.target.value;

                    setSelectedClass(classValue);

                    setFormData(prev => ({
                      ...prev,
                      className: classValue
                    }));
                  }}
                  required
                  disabled={!selectedSchool}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: errors.className
                      ? '1px solid red'
                      : '1px solid rgb(100, 19, 32)',
                    borderRadius: '5px',
                    fontSize: '0.9rem',
                    fontFamily: 'Lora',
                    color: 'rgb(100, 19, 32)',
                    backgroundColor: 'white',
                    cursor: selectedSchool ? 'pointer' : 'not-allowed'
                  }}
                >
                  <option value="">
                    {selectedSchool ? "Select Class *" : "Select School First"}
                  </option>

                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.class_name}>
                      {cls.class_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className='form-group'>
                <select
                  value={selectedState}
                  onChange={(e) => {
                    const stateValue = e.target.value;

                    setSelectedState(stateValue);

                    setFormData(prev => ({
                      ...prev,
                      state: stateValue
                    }));
                  }}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: errors.className
                      ? '1px solid red'
                      : '1px solid rgb(100, 19, 32)',
                    borderRadius: '5px',
                    fontSize: '0.9rem',
                    fontFamily: 'Lora',
                    color: 'rgb(100, 19, 32)',
                    backgroundColor: 'white',
                    cursor: 'pointer'
                  }}
                >
                  <option value="">Select State *</option>

                  {statesOfIndia.map((state, index) => (
                    <option key={index} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Enter City Name *"
                  value={formData.cityName}
                  onChange={(e) => handleNameChange("cityName", e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: errors.cityName
                      ? '1px solid red'
                      : '1px solid rgb(100, 19, 32)',
                    borderRadius: '5px',
                    fontSize: '0.9rem',
                    fontFamily: 'Lora',
                    color: 'rgb(100, 19, 32)'
                  }}
                />
                {errors.cityName && (
                  <small style={{ color: 'red' }}>{errors.cityName}</small>
                )}
              </div>
              <button
                type="submit"
                disabled={!formValid}
                style={{
                  background: formValid ? 'rgb(100, 19, 32)' : '#ccc',
                  color: 'white',
                  border: 'none',
                  padding: '10px 40px',
                  borderRadius: '5px',
                  fontSize: '1rem',
                  fontFamily: 'Lora',
                  cursor: formValid ? 'pointer' : 'not-allowed'
                }}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      )}

      {alertState.show && (
        <div className="custom-alert-overlay">
          <div className="custom-alert-card">
            <div className={`custom-alert-icon ${alertState.type}`}>
              {alertState.type === 'success' ? (
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              ) : (
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              )}
            </div>
            <h4 className="custom-alert-title">{alertState.title}</h4>
            <p className="custom-alert-message">{alertState.message}</p>
            <button 
              className="custom-alert-btn"
              onClick={() => {
                setAlertState(prev => ({ ...prev, show: false }));
                if (alertState.type === 'success') {
                  onClose();
                }
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default ApplyModal;